import { InviteCode, InviteCodeBase } from "@common/types/inviteCode";
import { OrganizationUserRole } from "@common/userOrganizationRoles";
import { OrganizationInviteWorkspaceAssignmentDto } from "./organization-invite-workspace-assignment.dto";

/**
 * Input type for OrganizationInviteDto constructor.
 * Accepts Base type from entity classes - requires workspaceAssignments to be loaded.
 */
export type OrganizationInviteDtoInput = InviteCodeBase & {
    workspaceAssignments: NonNullable<InviteCodeBase["workspaceAssignments"]>;
};

export class OrganizationInviteDto {
    static deserialize(dto: OrganizationInviteDto): InviteCode {
        return {
            id: dto.id,
            email: dto.email,
            used: dto.used,
            workspaceAssignments: dto.workspaceAssignments.map(
                OrganizationInviteWorkspaceAssignmentDto.deserialize,
            ),
            organizationRole: dto.organizationRole,
            iconColor: dto.iconColor,
            inviteLink: dto.inviteLink,
            createdAt: dto.createdAt,
            updatedAt: dto.updatedAt,
        };
    }

    id: number;
    email: string | null;
    used: boolean;
    workspaceAssignments: OrganizationInviteWorkspaceAssignmentDto[];
    organizationRole: OrganizationUserRole | null;
    iconColor: string;
    inviteLink: string;
    createdAt: Date;
    updatedAt: Date;

    constructor(invite: OrganizationInviteDtoInput) {
        this.id = invite.id;
        this.email = invite.email;
        this.used = invite.used;
        this.workspaceAssignments = invite.workspaceAssignments.map(
            (wa) =>
                new OrganizationInviteWorkspaceAssignmentDto({
                    workspace: wa.workspace,
                }),
        );
        this.organizationRole = invite.organizationRole ?? null;
        this.iconColor = invite.iconColor;
        this.inviteLink = invite.inviteLink;
        this.createdAt = invite.createdAt;
        this.updatedAt = invite.updatedAt;
    }
}
